export default class Attachment {
  constructor(object) {
    this.id = parseInt(object.id, 10)
    this.file = object.file
    this.path = object.path || undefined
  }
}
